import React, { ReactNode, useEffect } from 'react';
import { useManageContext } from '../contexts/ManageContext/ManageContext';

interface Props {
  name: string;
  children: ReactNode;
}

const Page = (props: Props) => {
  const { children, name } = props;
  const { dispatch } = useManageContext();

  useEffect(() => {
    dispatch({ type: 'page-changed', data: name });
  }, [dispatch, name]);

  return <>{children}</>;
};

export default Page;
